import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

export const PayableInvoicesConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "PayableInvoices" */
      '../../../components/Treasury/PayableInvoices/PayableInvoices'
    ),
  teamOwner: 'treasury',
  sentryTeam: 'treasury_surfaces',
  enabledKey: 'internal',
  releaseState: 'internal',
  description: 'A list of payable invoices for a connected account.',
  friendlyName: 'Payable invoices',
};
